import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import type {
  NotificationTemplateResponse,
  UpdateNotificationTemplateItem,
} from '../types';

export function useNotificationTemplates() {
  const { isFetching, data, refetch } = useApiQuery<NotificationTemplateResponse[]>(
    '/notification-templates',
    { queryKey: ['notificationTemplates'], initialData: [] }
  );

  const updateMutation = useApiMutation<
    { updates: UpdateNotificationTemplateItem[] },
    NotificationTemplateResponse[]
  >(
    '/notification-templates',
    { method: 'PATCH' },
    {
      onSuccess: () => {
        refetch();
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  const templates = [...(data ?? [])].sort((a, b) => {
    if (a.lang === 'en') return -1;
    if (b.lang === 'en') return 1;
    return 0;
  });

  return { isFetching, templates, updateMutation } as const;
}
